import axios from '../../v2/app/services/axiosService';
import * as types from '../../vuex/mutation-types';
import store from '../../vuex/store';
import _ from 'lodash';
import toastr from "toastr";

export default {
  async getStripeClientSecret() {
    const response = await axios.get(`/api/team/stripe/token`);
    return response.data;
  },
  async subscribeWithInvoice(teamID, form) {
    const response = await axios.post(`/api/teams/${teamID}/subscribe/invoice`, form);
    return response.data;
  },
  async subscribeWithCreditCard(teamID, form) {
    const response = await axios.post(`/api/teams/${teamID}/subscribe/credit-card`, form);
    return response.data;
  },
  async getSubscribers(presentationID) {
    const response = await axios.get(`/api/admin/presentations/${presentationID}/subscribers`);
    //const subscriberCount = response.data.length;
    //store.commit(types.SET_PRESENTATION_SUBSCRIBER_COUNT, subscriberCount);
    //store.commit(types.SET_PRESENTATION_SUBSCRIBERS, response.data);
    return response.data;
  },
  async getSubscriptions() {
    const response = await axios.get(`/api/admin/user/subscriptions/presentations`);
    const ids = _.map(response.data, p => p.id);
    store.commit(types.SET_SUBSCRIPTIONS, ids);
    return response.data;
  },
  async removeSubscriber(presentation, subscriber) {
    const response = await axios.delete(`/api/admin/presentations/${presentation.id}/subscribers/${subscriber.id}`);
    return response.data;
  },
  async subscribe(presentationID) {
    const data = {
      presentation_id: presentationID,
    };
    const response = await axios.post(`/api/admin/user/subscriptions/presentations`, data);
    this.getSubscribers(presentationID);
    this.getSubscriptions();
    return response.data;
  },
  subscribed(presentationID) {
    return store.state.subscriptions.includes(presentationID);
  },
  async unsubscribe(presentationID) {
    const response = await axios.delete(`/api/admin/user/subscriptions/presentations/${presentationID}`);
    this.getSubscribers(presentationID);
    this.getSubscriptions();
    return response.data;
  },
  async unsubscribeFromAll() {
    const response = await axios.delete(`/api/admin/user/subscriptions/presentations`);
    this.getSubscriptions();
    return response.data;
  }
}
